/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Response returned when an export job is accepted.
 */
export type FunnelConversationSearchExportResponse = {
    /**
     * Tracking identifier for the export request
     */
    requestId: string;
    /**
     * Enqueued job id
     */
    jobId: FunnelConversationSearchExportResponse.jobId;
};
export namespace FunnelConversationSearchExportResponse {
    /**
     * Enqueued job id
     */
    export enum jobId {
        CONVERSATION_TABLE_EXPORT = 'Conversation Table Export',
    }
}

